import { heroMeta } from '@/mocks/home';

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-background-100 border-b border-background-200/70">
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-primary-100/60 blur-3xl" aria-hidden="true"></div>
      <div className="absolute bottom-0 left-1/3 w-80 h-80 rounded-full bg-accent-100/50 blur-3xl" aria-hidden="true"></div>

      <div className="relative w-full px-4 md:px-10 py-14 md:py-20 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-[1.05fr_0.95fr] gap-10 lg:gap-14 items-center">
          <div className="anim-fade-up">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50 border border-primary-200 mb-6">
              <span className="w-2 h-2 rounded-full bg-primary-500 anim-pulse-soft" aria-hidden="true"></span>
              <span className="font-label text-xs text-primary-700 tracking-wide">
                官网入口 · 实时维护
              </span>
            </div>

            <h1 className="font-heading font-black text-foreground-950 text-3xl md:text-4xl lg:text-5xl leading-[1.2]">
              青苹果影院官网入口
              <br className="hidden md:block" />
              与最新地址一站收录
            </h1>

            <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-600 max-w-xl">
              本页为你整理<strong className="font-medium text-foreground-900">官网入口</strong>、
              <strong className="font-medium text-foreground-900">最新地址</strong>与
              <strong className="font-medium text-foreground-900">APP 下载</strong>方式。
              找不到网站、地址失效时，回到这里就能快速拿到当前有效的
              <strong className="font-medium text-foreground-900">官方网址</strong>，安心影视观看。
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="#address"
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 font-label text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-links-line text-lg" aria-hidden="true"></i>
                获取最新入口
              </a>
              <a
                href="#download"
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-background-50 border border-background-300 text-foreground-900 font-label text-sm font-medium hover:border-primary-400 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-download-2-line text-lg" aria-hidden="true"></i>
                下载 APP 客户端
              </a>
            </div>

            <div className="mt-9 grid grid-cols-3 gap-4 max-w-lg">
              {heroMeta.map((item) => (
                <div key={item.id} className="flex flex-col gap-1">
                  <span className="flex items-center gap-1.5 font-label text-[11px] text-foreground-500">
                    <i className={`${item.icon} text-primary-600 text-sm`} aria-hidden="true"></i>
                    {item.label}
                  </span>
                  <span className="font-heading font-bold text-sm text-foreground-950">
                    {item.value}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="relative anim-fade-up" style={{ animationDelay: '0.15s' }}>
            <div className="relative w-full max-w-md mx-auto">
              <div className="w-full aspect-[4/5] rounded-lg overflow-hidden border border-background-300/70 bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20emerald%20green%20streaming%20app%20interface%20concept%20with%20glowing%20glass%20panels%20and%20floating%20movie%20cover%20thumbnails%2C%20soft%20neon%20green%20rim%20light%2C%20minimal%20modern%20editorial%20tech%20aesthetic%2C%20premium%20magazine%20composition%2C%20deep%20contrast%20and%20clean%20empty%20space&width=1000&height=1250&seq=qpg-hero-cover&orientation=portrait"
                  alt="青苹果影院官网入口与最新地址展示封面"
                  title="青苹果影院官网入口 最新地址 APP下载"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="absolute -left-4 md:-left-8 top-8 anim-float">
                <div className="bg-background-50 rounded-lg border border-background-200 px-4 py-3 shadow-none">
                  <span className="flex items-center gap-2 font-label text-[11px] text-foreground-500">
                    <span className="w-2 h-2 rounded-full bg-primary-500 anim-pulse-soft" aria-hidden="true"></span>
                    当前入口状态
                  </span>
                  <span className="font-heading font-bold text-base text-foreground-950 mt-1 block">
                    正常可用
                  </span>
                </div>
              </div>

              <div className="absolute -right-3 md:-right-6 bottom-10 anim-float" style={{ animationDelay: '1.2s' }}>
                <div className="bg-primary-500 text-background-50 dark:text-foreground-950 rounded-lg px-4 py-3">
                  <span className="font-label text-[11px] opacity-90">已收录有效入口</span>
                  <span className="font-heading font-black text-2xl block leading-tight">6 条</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}